import axios from "axios";
import { toast } from "react-toastify";
import { store } from "store";

const origin = window.location.origin;

const getbackendurl = () => {
  switch (origin) {
    case "https://www.begnh.com":
      return "https://beglobal-api.begnh.com";
    default:
      return "https://api.erp.gurugeeksroyalty.biz";
  }
};

export const baseURL = `${getbackendurl()}/api/v1/`;
export const operations_path = "/operations/";
export const fetcher = axios.create({ baseURL });

export const apiRequest = async ({
  method = "get",
  url,
  payload,
  hasAuth,
  showError = true,
  contentType = "application/json",
  successMeggage,
}) => {
  let updated_url = url;

  const { access_token } = store.getState().user;
  const headers = {
    headers: hasAuth
      ? {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": contentType,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          "Access-Control-Allow-Methods": "OPTIONS, PUT",
        }
      : {
          "Content-Type": contentType,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: `Bearer ${access_token}`,
        },
  };
  // console.log(hasAuth)
  const args =
    method === "get" || method === "delete"
      ? [updated_url, headers]
      : [updated_url, payload, headers];

  try {
    const data = await fetcher[method.toLowerCase()](...args);
    successMeggage && toast.success(successMeggage);

    return data;
  } catch (error) {
    const errors = error?.response?.data?.data?.errors;
    // console.log(error)
    if (errors) {
      let messages = Object.values(errors);

      messages.map((message) => {
        if (message.length) {
          message.map((innerMessage) =>
            toast.error(innerMessage, { toastId: innerMessage })
          );
        } else {
          toast.error(message, { toastId: message });
        }
        return message;
      });
      // return messages
    } else {
      const err = error?.response?.data?.data?.error?.message;
      if (error?.response?.status !== 500) {
        if (err === "Access Token has expired") {
          toast.error(err);
          window.location.replace(origin);
        }
      }

      // return err
    }
    if (error?.response?.status === 401) {
      throw new Error("You are not autorized");
    } else {
      throw error;
    }
  }
};
